import script from "./ReminderDefinitionFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderDefinitionFormModal.vue?vue&type=script&setup=true&lang=js"

import "./ReminderDefinitionFormModal.vue?vue&type=style&index=0&id=dba7b5ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dba7b5ba"]])

export default __exports__